import { render, staticRenderFns } from "./gptGround.vue?vue&type=template&id=15d837d5&scoped=true"
import script from "./gptGround.vue?vue&type=script&lang=js"
export * from "./gptGround.vue?vue&type=script&lang=js"
import style0 from "./gptGround.vue?vue&type=style&index=0&id=15d837d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d837d5",
  null
  
)

export default component.exports